import {
  UsersIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  TicketIcon,
  IdentificationIcon,
  DocumentIcon,
} from "@heroicons/react/24/outline";
import i18n from "i18next";

export function getRepresentativeMenus() {
  return [
    {
      label: i18n.t("menu.overview"),
      icon: ChartBarIcon,
      link: "/representative-dashboard",
    },
    {
      label: i18n.t("adminUserTable.title"),
      icon: UsersIcon,
      link: "/representative-dashboard-users",
    },
    {
      label: i18n.t("followUps.title"),
      icon: CalendarDaysIcon,
      link: "/representative-followups",
    },
    {
      label: i18n.t("global.reservations"),
      icon: TicketIcon,
      link: "/representative-customers-reservation",
    },
    {
      label: i18n.t("global.myPublicProfile"),
      icon: IdentificationIcon,
      link: "/representative-public-profile",
    },
    {
      label: i18n.t("global.documents"),
      icon: DocumentIcon,
      link: "/representative/documents",
    },
  ];
}
